(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function raelLegacyRailRecovery() {
  const STYLE_ID = 'rael-legacy-rail-recovery';
  const RAIL_SELECTOR = '.rael-product-rail';
  const PRODUCT_LIMIT = 8;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .rael-product-rail--legacy-slider .rael-product-rail__carousel {
        display: flex;
        align-items: center;
        gap: 14px;
        position: relative;
      }

      .rael-product-rail--legacy-slider .rael-product-rail__viewport {
        flex: 1 1 auto;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
        -ms-overflow-style: none;
        scrollbar-width: none;
        padding-bottom: 6px;
      }

      .rael-product-rail--legacy-slider .rael-product-rail__viewport::-webkit-scrollbar {
        display: none;
      }

      .rael-product-rail--legacy-slider .rael-card-rail {
        display: flex !important;
        flex-wrap: nowrap !important;
        align-items: stretch;
        gap: 32px;
        width: max-content;
      }

      .rael-product-rail--legacy-slider .rael-product-card {
        scroll-snap-align: start;
      }

      .rael-product-rail--legacy-slider .rael-product-rail__nav {
        width: 42px;
        height: 42px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(24, 61, 52, 0.14);
        border-radius: 999px;
        background: #fffdf7;
        color: #244a3f;
        cursor: pointer;
        box-shadow: 0 8px 18px rgba(36, 74, 63, 0.08);
        flex: 0 0 auto;
        transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
      }

      .rael-product-rail--legacy-slider .rael-product-rail__nav svg {
        width: 18px;
        height: 18px;
      }

      .rael-product-rail--legacy-slider .rael-product-rail__nav:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 12px 22px rgba(36, 74, 63, 0.14);
      }

      .rael-product-rail--legacy-slider .rael-product-rail__nav:disabled {
        opacity: 0.35;
        cursor: default;
        box-shadow: none;
      }

      @media screen and (max-width: 989px) {
        .rael-product-rail--legacy-slider .rael-product-rail__carousel {
          gap: 0;
        }

        .rael-product-rail--legacy-slider .rael-product-rail__nav {
          display: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createNavButton(direction) {
    const button = document.createElement('button');
    const isPrev = direction === 'prev';

    button.type = 'button';
    button.className = `rael-product-rail__nav rael-product-rail__nav--${direction}`;
    button.setAttribute('aria-label', isPrev ? 'Previous products' : 'Next products');
    button.innerHTML = isPrev
      ? '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M11.75 4.5L6.25 10l5.5 5.5"></path></svg>'
      : '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M8.25 4.5L13.75 10l-5.5 5.5"></path></svg>';

    return button;
  }

  function formatPrice(rawPrice) {
    const numeric = Number(rawPrice);
    if (!Number.isFinite(numeric)) return '';

    const normalized = numeric > 999 ? numeric / 100 : numeric;
    return `$${normalized.toFixed(2)}`;
  }

  function getCollectionPath(root) {
    const footerLink = root.querySelector('.rael-product-rail__footer a[href*="/collections/"]');
    if (footerLink) return footerLink.getAttribute('href');

    return '/collections/best-seller';
  }

  async function hydrateLegacyCards(root, track) {
    if (root.dataset.legacyRailHydrated === 'true') return;
    root.dataset.legacyRailHydrated = 'pending';

    try {
      const collectionPath = getCollectionPath(root);
      const response = await fetch(`${collectionPath.replace(/\/$/, '')}/products.json?limit=${PRODUCT_LIMIT}`, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) throw new Error(`Legacy rail fetch failed (${response.status})`);

      const payload = await response.json();
      const products = Array.isArray(payload?.products) ? payload.products : [];
      const cards = [...track.querySelectorAll(':scope > .rael-product-card')];

      products.slice(0, cards.length).forEach((product, index) => {
        const card = cards[index];
        if (!card) return;

        const mediaLink = card.querySelector('.rael-product-card__media a');
        const titleLink = card.querySelector('.rael-product-card__title-link');
        const image = card.querySelector('img');
        const priceNode = card.querySelector('.rael-product-card__price');
        const productPath = `/products/${product.handle}`;
        const title = product.title || '';
        const imageSource =
          product?.images?.[0]?.src || product?.featured_image || product?.image?.src || image?.getAttribute('src') || '';
        const price = formatPrice(product.price ?? product?.variants?.[0]?.price);

        if (mediaLink) {
          mediaLink.setAttribute('href', productPath);
          mediaLink.setAttribute('aria-label', title);
        }

        if (titleLink) {
          titleLink.setAttribute('href', productPath);
          titleLink.textContent = title;
        }

        if (image && imageSource) {
          image.setAttribute('src', imageSource);
          image.setAttribute('alt', title);
        }

        if (priceNode && price) {
          priceNode.textContent = price;
        }
      });

      root.dataset.legacyRailHydrated = 'true';
    } catch (error) {
      root.dataset.legacyRailHydrated = 'failed';
      console.warn('Rael legacy rail hydration failed:', error);
    }
  }

  function syncCardWidths(root) {
    const viewport = root.querySelector('[data-rail-viewport]');
    const cards = root.querySelectorAll('.rael-card-rail > .rael-product-card');

    if (!viewport || !cards.length) return;

    const isMobile = window.innerWidth < 750;
    const gap = isMobile ? 16 : 32;
    const visibleCards = isMobile ? 1.16 : window.innerWidth < 1100 ? 2.85 : 3.38;
    const viewportWidth = viewport.clientWidth || root.clientWidth || window.innerWidth;
    const cardWidth = isMobile
      ? Math.max(292, Math.min(330, (viewportWidth - gap) / visibleCards))
      : Math.max(320, Math.min(378, (viewportWidth - gap * (Math.ceil(visibleCards) - 1)) / visibleCards));

    cards.forEach((card) => {
      card.style.flex = `0 0 ${cardWidth}px`;
    });
  }

  function updateRailState(root) {
    const viewport = root.querySelector('[data-rail-viewport]');
    const prev = root.querySelector('.rael-product-rail__nav--prev');
    const next = root.querySelector('.rael-product-rail__nav--next');

    if (!viewport || !prev || !next) return;

    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
    prev.disabled = viewport.scrollLeft <= 2;
    next.disabled = viewport.scrollLeft >= maxScroll;
  }

  function bindLegacyRail(root) {
    const viewport = root.querySelector('[data-rail-viewport]');
    const prev = root.querySelector('.rael-product-rail__nav--prev');
    const next = root.querySelector('.rael-product-rail__nav--next');

    if (!viewport || !prev || !next || root.dataset.legacyRailBound === 'true') return;

    const scrollByAmount = () => Math.max(viewport.clientWidth * 0.86, 260);

    prev.addEventListener('click', () => {
      viewport.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      viewport.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', () => updateRailState(root), { passive: true });
    root.dataset.legacyRailBound = 'true';
    updateRailState(root);
  }

  function upgradeLegacyRail(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.legacyRailReady === 'true') return;
    if (root.querySelector('[data-rail-viewport]')) return;

    const shell = root.querySelector('.rael-shell');
    if (!shell) return;

    const directTrack = [...shell.children].find((node) => node.classList?.contains('rael-card-rail'));
    if (!directTrack) return;

    const footer = [...shell.children].find((node) => node.classList?.contains('rael-product-rail__footer'));
    const carousel = document.createElement('div');
    const viewport = document.createElement('div');
    const prev = createNavButton('prev');
    const next = createNavButton('next');

    carousel.className = 'rael-product-rail__carousel';
    viewport.className = 'rael-product-rail__viewport';
    viewport.setAttribute('data-rail-viewport', '');

    root.classList.add('rael-product-rail--legacy-slider');
    carousel.appendChild(prev);
    carousel.appendChild(viewport);
    carousel.appendChild(next);
    viewport.appendChild(directTrack);

    if (footer) {
      shell.insertBefore(carousel, footer);
    } else {
      shell.appendChild(carousel);
    }

    root.dataset.legacyRailReady = 'true';
    bindLegacyRail(root);
    syncCardWidths(root);
    updateRailState(root);
    hydrateLegacyCards(root, directTrack);
  }

  function initRails(context) {
    injectStyles();

    const roots =
      context instanceof Element && context.matches?.(RAIL_SELECTOR)
        ? [context]
        : [...(context.querySelectorAll ? context.querySelectorAll(RAIL_SELECTOR) : [])];

    roots.forEach((root) => upgradeLegacyRail(root));
  }

  function initWhenReady() {
    initRails(document);
    window.requestAnimationFrame(() => initRails(document));
    window.setTimeout(() => initRails(document), 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }

  window.addEventListener('load', initWhenReady);
  window.addEventListener('resize', () => {
    document.querySelectorAll(`${RAIL_SELECTOR}[data-legacy-rail-ready="true"]`).forEach((root) => {
      syncCardWidths(root);
      updateRailState(root);
    });
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initRails(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
